import type { TableRowProps } from '@mui/material/TableRow';

import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

// ----------------------------------------------------------------------

export default function TableSkeleton({ ...other }: TableRowProps) {
  return (
    <TableRow sx={{ width: '100%' }} {...other}>
      <TableCell colSpan={12}>
        <Stack alignItems="center" spacing={3} direction="row">
          <Skeleton
            sx={{ borderRadius: 1.5, width: 48, height: 48, flexShrink: 0 }}
          />
          <Skeleton sx={{ width: 1, height: 24 }} />
          <Skeleton sx={{ width: 180, height: 24 }} />
          <Skeleton sx={{ width: 160, height: 24 }} />
          <Skeleton sx={{ width: 140, height: 24 }} />
          <Skeleton sx={{ width: 120, height: 24 }} />
        </Stack>
      </TableCell>
    </TableRow>
  );
}
